window.axios = require("axios")

import store from './store'

window.axios.defaults.baseURL = process.env.VUE_APP_API_DOMAIN;
window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

if(process.env.VUE_APP_ENV === 'production') {
    window.axios.defaults.withCredentials = true;
    window.axios.defaults.headers.common['Access-Control-Allow-Credentials'] = true;
}

let user = store.getters["auth/getUser"];
if(user) {
    window.axios.defaults.headers.common = {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
        'Authorization': 'Bearer ' + user.access_token
    }
}
